/**
 * VÉRAULT — Global ScrollToTop
 *
 * Listens for route changes and scrolls the window back to the top. Fixes
 * the long-standing mobile issue where tapping a CTA would land the user
 * at the bottom of the next page (because the new page mounts under the
 * existing scroll position).
 *
 * Mounted once at the top of <App />. No props, no state, no UI.
 * Honors browser back/forward (which preserves scroll) and hash-anchored
 * deep links (#section) — only resets when the pathname truly changes.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Hash deep-links (#destinations etc) handle their own anchor scroll.
    if (hash) return;
    // Respect prefers-reduced-motion when available.
    const behaviour = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? "auto"
      : "instant";
    try {
      window.scrollTo({ top: 0, left: 0, behavior: behaviour });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
